import { handleResponse, Headers } from "../_helpers";

export const EventTypesService = {
  getGlobalEventTypes,
};

function getGlobalEventTypes() {
  const request = {
    method: "GET",
    headers: Headers.set({ auth: false }),
  };

  return fetch(`${process.env.API_URL}/api/v1/event/types`, request)
    .then(handleResponse)
    .then((eventTypes) => eventTypes);
}
